/* SM WORKS Rabattcode (Thomas 04.11.2026), Markup: snippets/smw-rabatt.liquid. Der Drawer wird nach jeder Änderung neu aufgebaut, darum alles über document. */
(function () {
  var FEHLER = 'Dieser Code ist ungültig oder gilt nicht für deinen Warenkorb.';
  var NETZ = 'Das hat gerade nicht geklappt. Bitte versuche es noch einmal.';

  function senden(codes, mitSections) {
    var body = { discount: codes.join(',') };
    if (mitSections) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    return fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error('Warenkorb ' + r.status);
      return r.json();
    });
  }

  function aktive(wurzel) {
    return Array.prototype.map.call(wurzel.querySelectorAll('[data-smw-rabatt-weg]'), function (b) {
      return b.getAttribute('data-smw-rabatt-weg');
    });
  }

  function neuAufbauen(wurzel, stand) {
    var drawer = wurzel.closest('cart-drawer');
    if (drawer && drawer.renderContents && stand.sections) return drawer.renderContents(stand);
    window.location.reload();
  }

  function fehler(wurzel, text) {
    var f = wurzel.querySelector('[data-smw-rabatt-fehler]');
    if (!f) return;
    f.textContent = text;
    f.hidden = false;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-smw-rabatt-form]');
    if (!form) return;
    e.preventDefault();
    var wurzel = form.closest('[data-smw-rabatt]');
    var feld = form.querySelector('input');
    var knopf = form.querySelector('button');
    var code = feld.value.trim();
    if (!code) return feld.focus();

    var vorher = aktive(wurzel);
    var doppelt = vorher.some(function (c) { return c.toLowerCase() === code.toLowerCase(); });
    if (doppelt) { feld.value = ''; return; }

    knopf.disabled = true;
    wurzel.querySelector('[data-smw-rabatt-fehler]').hidden = true;
    senden(vorher.concat(code), true)
      .then(function (stand) {
        var treffer = (stand.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
        if (treffer && treffer.applicable) return neuAufbauen(wurzel, stand);
        /* Shopify merkt sich auch ungültige Codes, darum den alten Stand wieder setzen */
        fehler(wurzel, FEHLER);
        knopf.disabled = false;
        return senden(vorher, false);
      })
      .catch(function () {
        fehler(wurzel, NETZ);
        knopf.disabled = false;
      });
  });

  document.addEventListener('click', function (e) {
    var weg = e.target.closest && e.target.closest('[data-smw-rabatt-weg]');
    if (!weg) return;
    var wurzel = weg.closest('[data-smw-rabatt]');
    var code = weg.getAttribute('data-smw-rabatt-weg');
    weg.disabled = true;
    senden(aktive(wurzel).filter(function (c) { return c !== code; }), true)
      .then(function (stand) { neuAufbauen(wurzel, stand); })
      .catch(function () {
        weg.disabled = false;
        fehler(wurzel, NETZ);
        var auf = wurzel.querySelector('details');
        if (auf) auf.open = true;
      });
  });

  /* Beim Aufklappen gleich ins Feld, am Handy geht die Tastatur auf */
  document.addEventListener('toggle', function (e) {
    if (!e.target.matches || !e.target.matches('.smw-rabatt__auf') || !e.target.open) return;
    var feld = e.target.querySelector('input');
    if (feld) feld.focus({ preventScroll: true });
  }, true);
})();
